import React, { Component } from 'react';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import { Box, Menu, X } from 'react-feather';
import EscapatLogo from './escapat-logo.png'

class Header extends Component {
  constructor() {
    super();
    this.state = {
      quantity: 0,
      showDropDown: false,
    }
    this.toggleDropDown = this.toggleDropDown.bind(this)
  }

  calcQuantity() {
    let cartItems = 0
    this.props.cart.map((item) => {
      return cartItems += item.quantity
    })
    this.setState({quantity: cartItems})
  }

  updateQuantity(nextProps) {
    let cartItems = 0
    nextProps.cart.map((item) => {
      return cartItems += item.quantity
    })
    this.setState({quantity: cartItems})
  }

  toggleDropDown(){
    this.setState(prevState => ({showDropDown: !prevState.showDropDown}))
  }

  componentDidMount() {
    this.calcQuantity()
  }

  componentWillReceiveProps(nextProps) {
    this.updateQuantity(nextProps)
  }

  render() {
    return (
      <div>
        <div className={this.state.showDropDown ? "Header-dropdown show" : "Header-dropdown"}>
          <div className="Header-links" onClick={this.toggleDropDown}>
            <Link to="/" className={this.props.location.pathname === '/' ? 'active' : ''}>
              {this.props.auth.isAuthenticated ? "Mitt Abonnemang" : "Skapa Abonnemang" }
            </Link>
            <Link to="/info" className={this.props.location.pathname === '/info' ? 'active' : ''}>Info</Link>
            {
              this.props.auth.isAuthenticated
              ?
              <Link
                to="/konto"
                className={
                  this.props.location.pathname === '/konto' | this.props.location.pathname
                  ===
                  '/konto/betalningsmetod'
                  ?
                  'active'
                  :
                  ''
                }>
                Konto
              </Link>
              :
              <button onClick={this.props.toggleSignIn}>Logga In</button>
            }
          </div>
        </div>
        <div className="Header container">
          {
            this.state.showDropDown
            ?
            <X className="Header-menu" onClick={this.toggleDropDown} />
            :
            <Menu className="Header-menu" onClick={this.toggleDropDown} />
          }
          <div className="Header-links">
            <Link to="/" className={this.props.location.pathname === '/' ? 'active' : ''}>
              {this.props.auth.isAuthenticated ? "Mitt Abonnemang" : "Skapa Abonnemang" }
            </Link>
            <Link to="/info" className={this.props.location.pathname === '/info' ? 'active' : ''}>Info</Link>
            {
              this.props.auth.isAuthenticated
              ?
              <Link
                to="/konto"
                className={
                  this.props.location.pathname === '/konto' | this.props.location.pathname
                  ===
                  '/konto/betalningsmetod'
                  ?
                  'active'
                  :
                  ''
                }>
                Konto
              </Link>              
              :
              <button onClick={this.props.toggleSignIn}>Logga In</button>
            }
          </div>
          <img className="Header-logo" src={EscapatLogo} alt="Escapt vinabonnemang logga" />
          <div>
            <button className="Header-box-btn" onClick={this.props.showCart}>
              {
                this.props.auth.isAuthenticated
                ?
                <p>Översikt</p>
                :
                <p>Kassa</p>
              }
              <Box/>
              {
                this.state.quantity > 0
                ?
                <span className="Header-box-quantity">{this.state.quantity}</span>
                :
                null
              }
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    cart: state.cart,
    auth: state.auth
  }
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/Header.jsx